<div class="d-flex justify-content-center align-items-center" [style]="'width: 100%; padding: 32px; min-height: '+minHeight+'px;'">
    <div class="d-flex flex-column justify-content-center align-items-center" style="gap:8px;">
        <ng-container *ngIf="image">
            <img *ngIf="image == 'section'" src="/assets/empty_section.svg" />
            <img *ngIf="image == 'preview'" src="/assets/empty_section_preview.svg" />
        </ng-container>
        <ng-container *ngIf="!image && big == false">
            <app-icon-circle [iconClass]="'material-icons-outlined color-icon-disabled'">{{iconName}}</app-icon-circle>
        </ng-container>
        <ng-container *ngIf="!image && big == true">
            <app-icon-circle [iconClass]="'material-icons-outlined color-icon-disabled'" style="transform:scale(3.35);">{{iconName}}</app-icon-circle>
            <div style="height: 40px;"></div>
        </ng-container>
        <div class="mat-headline">{{title}}</div>
        <div class="eac-c1" style="text-align: center;">
            {{description}}
        </div> 
        <div *ngIf="actionTitle!=null" style="padding-top: 32px;">
            <button mat-flat-button color="primary" (click)="action.emit(true)">
                {{actionTitle}} <mat-icon  *ngIf="actionIsSelect" inline="true">arrow_drop_down</mat-icon>
            </button>

        </div>           
    </div>

</div>
